import React from 'react';
import { Field, DatePicker, TimePicker, GroupField, InputNumber } from '@components';
import styled from 'styled-components';

const FieldDtExecucao = styled(Field)`
  margin-left: 0;
  width: 100%;
`;

export default function Intervalo() {
  return (
    <GroupField>
      <FieldDtExecucao label='Período de execução' name='periodoDtExecucao'>
        <DatePicker.RangePicker format='DD/MM/YYYY' />
      </FieldDtExecucao>
      <Field label='Executar entre' name='periodoHrExecucao'>
        <TimePicker.RangePicker format='HH:mm:ss' />
      </Field>
      <Field label='Intervalo entre execuções' name='intervalo'>
        <InputNumber />
      </Field>
    </GroupField>
  );
}
